import { invariant } from '@seen/core/invariant'
import { RecentSelections } from '@seen/core/models/recentSelections'
import { useCallback } from 'react'
import { useCurrentPractitioner } from '#src/hooks/useCurrentPractitioner.ts'
import { usePatchMutation } from '#src/hooks/usePatchMutation.ts'
import { useRead } from '#src/hooks/useRead.ts'

export function useAddRecentSelection(): (selection: string) => Promise<void> {
  const currentPractitioner = useCurrentPractitioner()
  const patchRecentSelections = usePatchMutation<RecentSelections>(
    currentPractitioner.recentSelections?.reference
      ? {
          mutation: {
            scope: {
              id: currentPractitioner.recentSelections.reference,
            },
          },
        }
      : undefined
  ).mutate

  const { data: recentSelections } = useRead(
    RecentSelections,
    currentPractitioner.recentSelections
  )

  return useCallback(
    async (selection: string) => {
      invariant(recentSelections, 'Recent selections not found')
      patchRecentSelections({
        instance: recentSelections,
        mutateFn: (rs) => rs.add(selection),
      })
    },
    [patchRecentSelections, recentSelections]
  )
}
